import React from "react";
import FundAnalysis from "../../features/icfundanalysis";

const FundAnalysisVolatilityPage = () => <FundAnalysis isVolatility />

export default FundAnalysisVolatilityPage;